var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"date"},[_c('b',[_vm._v(_vm._s(_vm.computedDate))])]),_c('div',{staticClass:"time"},[_c('b',[_vm._v(_vm._s(_vm.computedTime))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }